import React from 'react';
import Modal from '../modal/Modal';
import PunishedForm from './form';
import AcceptModal from "../accept_modal/AcceptModal";
import SearchForm from "../searchForm/SearchForm";
import { toast } from "react-toastify";
import PunishedApi from "../../api/Punished";
import PlayersApi from "../../api/Players";
import * as moment from 'moment';
import 'moment/locale/es';
import { Link } from 'react-router-dom';

export default class Punished extends React.Component{
    players = [];
    constructor(){
        super();
        this.state = {
            showModal: false,
            data: [],
            players: [],
            modalTitle: "",
            selected: null,
            showAcceptModal: false,
            filterText: ""
        };
        moment.locale('es');
    }

    componentWillMount(){
        let st = this.state
        PlayersApi.getAll().then(r => {
            // st.data = r.data.response
            st.players = r.data.response;
            return PunishedApi.getAll();
        }).then(r => {
            st.data.punished = r.data.response;
            console.log(r.data.response)
            this.setState(st);
        })
    }

    edit(player){
        let st = this.state
        st.modalTitle = "Editar";
        st.showModal = true;
        st.selected = player;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    save(player){
        if(!player.id){
            player.status = 1;
            player.user_id = localStorage.getItem("id");
            player.start_date = moment(player.startDate).format("DD/MM/YYYY");
            player.end_date = moment(player.endDate).format("DD/MM/YYYY");
            PunishedApi.create(player).then(res => {
                let state = {...this.state};
                state.data.punished.push(res.data.response);
                this.setState(state);
                toast.success("La sanción se guardó correctamente");
            }).catch(err => console.log(err));
        }else{
            let aux = player.start_date
            let aux2 = player.end_date
            player.start_date = moment(player.startDate).format("YYYY/MM/DD");
            player.end_date = moment(player.endDate).format("YYYY/MM/DD");
            PunishedApi.edit(player).then(res => {
                let state = {...this.state};
                // player.start_date = aux
                // player.end_date = aux2
                state.data.punished[state.data.punished.findIndex(t => t.id === player.id)] = res.data.response;
                state.selected = null;
                this.setState(state);
                toast.success("Datos actualizados");
            })

        }
        this.closeModal();
    }

    create(){
        let st = this.state
        st.modalTitle = "Nuevo sancionado";
        st.showModal = true;
        st.selected = null;
        this.setState(st);
    }

    remove(){
        PunishedApi.delete(this.state.selected.id).then(res => {
            if(res.data.response){
                let state = {...this.state};
                state.data.punished.splice(state.data.punished.findIndex(t => t.id === state.selected.id),1);
                state.selected = null;
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Sanción eliminada");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        })
    }

    delete(player){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = player;
        this.setState(state);
    }

    handleSearchInput(text){
        let players = this.players.filter(player => player.name.toLowerCase().includes(text.toLowerCase())||
        player.team.toLowerCase().includes(text.toLowerCase()));
        let state = this.state;
        state.filterText = text;
        state.data = players;
        this.setState(state);
    }

    render(){
        console.log(this.state)
        return(
            <div className="card-content">
                <div className="columns">
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <SearchForm
                                    filterText={this.state.filterText}
                                    onInput={(t) => this.handleSearchInput(t)}
                                    itemName={'jugador'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <a className="button is-outlined is-primary" onClick={(e) => this.create()}>Agregar sancionado</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Jugador</th>
                                <th># Camiseta</th>
                                <th>Equipo</th>
                                <th>Fechas sanción</th>
                                <th>Días sanción</th>
                                <th>Días restantes</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.data.punished && this.state.data.punished.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <td><a title={d.name}>{d.name}</a></td>
                                        <td>{d.number}</td>
                                        <td><Link to={'/Detalles/equipo/'+d.team_id} >{d.team}</Link></td>
                                        <td  title="fechas sancion">{moment(d.start_date).format("DD MMM YY",true)+" a "+moment(d.end_date).format("DD MMM YY",true)}</td>
                                        <td>{moment(d.end_date).diff(moment(d.start_date), 'days')}</td>
                                        <td>{(moment(d.end_date).diff(moment(), 'days')) > 0 ? moment(d.end_date).diff(moment(), 'days') : "0"}</td>
                                        <td>
                                            <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-edit"/>
                                                </span>
                                            </a>
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-trash"/>
                                                </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data}
                    cancel={() => this.closeModal()}
                >
                    <PunishedForm
                        selected = { this.state.selected }
                        players = {this.state.players}
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                    />
                </Modal>
                }

                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    modalTitle={"Eliminar sanción"}
                />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/punished/Punished.js